<app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle" [sw]="sw"></app-mensajes>
